import C5BaseDAO from "./C5BaseDAO";
import CategoriaModel from "../../model/CategoriaModel";
import ProdutoModel from "../../model/ProdutoModel";

class C5CategoriaDAO extends C5BaseDAO {
  private static instance: C5CategoriaDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): C5CategoriaDAO {
    if (!C5CategoriaDAO.instance) {
      C5CategoriaDAO.instance = new C5CategoriaDAO();
    }
    return C5CategoriaDAO.instance;
  }

  public async getPrimeiroNivel(): Promise<CategoriaModel[]> {
    return await this.get(
      "REQ_C5_CATEGORIA_PN",
      `${this.endpoint}/Category`
    ).then((r: any) => r.data.map((i: any) => CategoriaModel.toModel(i, 1)));
  }

  public async getPrimeiroNivelProdutos(
    categoriaId: string,
    lojaId: string
  ): Promise<ProdutoModel[]> {
    return await this.get(
      `REQ_C5_CATEGORIA_PN_PRODUTOS_${categoriaId}`,
      `${this.endpoint}/Store?PageCount=10&IDCategory=${categoriaId}&StoreID=${lojaId}`
    ).then((r: any) =>
      r.data.Products.filter((p: any) =>
        ProdutoModel.temEstoque(p)
      ).map((i: any) => ProdutoModel.toModel(i))
    );
  }

  public async getPrimeiroNivelTodosProdutos(
    categoriaId: string,
    lojaId: string
  ): Promise<ProdutoModel[]> {
    return await this.get(
      `REQ_C5_CATEGORIA_PN_PRODUTOS_${categoriaId}`,
      `${this.endpoint}/Store?PageCount=1000&IDCategory=${categoriaId}&StoreID=${lojaId}`
    ).then((r: any) =>
      r.data.Products.filter((p: any) =>
        ProdutoModel.temEstoque(p)
      ).map((i: any) => ProdutoModel.toModel(i))
    );
  }

  public async getSegundoNivel(categoriaId: string): Promise<CategoriaModel[]> {
    return await this.get(
      `REQ_C5_CATEGORIA_SN_${categoriaId}`,
      `${this.endpoint}/Category/${categoriaId}/SubCategory`
    ).then((r: any) => r.data.map((i: any) => CategoriaModel.toModel(i, 2)));
  }

  public async getSegundoNivelProdutos(
    categoriaId: string,
    subcategoriaId: string | undefined,
    lojaId: string | null,
    qtd: number = 50
  ): Promise<ProdutoModel[]> {
    return await this.get(
      `REQ_C5_CATEGORIA_SN_PRODUTOS_${categoriaId}_${subcategoriaId}`,
      `${this.endpoint}/Store?PageCount=${qtd}&IDCategory=${categoriaId}&IDSubCategory=${subcategoriaId}&StoreID=${lojaId}`
    ).then((r: any) =>
      r.data.Products.filter((p: any) =>
        ProdutoModel.temEstoque(p)
      ).map((i: any) => ProdutoModel.toModelByCategoriaProduto(i, ""))
    );
  }

  public async getTerceiroNivel(
    categoriaId: string,
    subcategoriaId: string
  ): Promise<CategoriaModel[]> {
    return await this.get(
      `REQ_C5_CATEGORIA_TN_${categoriaId}_${subcategoriaId}`,
      `${this.endpoint}/Category/${categoriaId}/SubCategory/${subcategoriaId}/TrdCategory`
    ).then((r: any) =>
      r.data.map((i: any) => CategoriaModel.toModel(i, 3))
    );
  }

  public async getTerceiroNivelProdutos(
    categoriaId: string,
    subcategoriaId: string | undefined,
    subsubcategoriaId: string | undefined,
    lojaId: string | null
  ): Promise<ProdutoModel[]> {
    if (lojaId && categoriaId && subcategoriaId && subsubcategoriaId) {
      return await this.get(
        `REQ_C5_CATEGORIA_TN_PRODUTOS_${categoriaId}_${subcategoriaId}_${subsubcategoriaId}`,
        `${this.endpoint}/Store?PageCount=100&IDCategory=${categoriaId}` +
          `&IDSubCategory=${subcategoriaId}&IDTriCategory=${subsubcategoriaId}&StoreID=${lojaId}`
      ).then((r: any) =>
        r.data.Products.filter((p: any) =>
          ProdutoModel.temEstoque(p)
        ).map((i: any) => ProdutoModel.toModelByCategoriaProduto(i, ""))
      );
    } else {
      throw new Error("Loja não encontrada");
    }
  }
}

export default C5CategoriaDAO;
